import "./styles.css";

import Footer from "./Footer";
import Search from "./Search";

export default function Box() {
  return (
    <div className="Box">
      <Search />
      <Footer />
    </div>
  );
}
